
import React from 'react';

import { Dialog } from '../../../../base/dialog';
import { translate } from '../../../../base/i18n';
import { Switch } from '../../../../base/react';
import { connect } from '../../../../base/redux';
import AbstractStartLocalRecordingDialog, {
    mapStateToProps
} from '../AbstractStartLocalRecordingDialog';

/**
 * React Component for getting confirmation to start a local recording session.
 *
 * @augments Component
 */
class StartLocalRecordingDialog extends AbstractStartLocalRecordingDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { onlySelf } = this.state;
        const { _hasLocalMedia, _hasLocalVideo, t } = this.props;
        const noSelfMedia = onlySelf && !_hasLocalMedia;
        const audioOnly = onlySelf && _hasLocalMedia && !_hasLocalVideo;

        return (
            <Dialog
                okDisabled = { noSelfMedia }
                okKey = 'localRecordingDialog.start'
                onSubmit = { this._onSubmit }
                titleKey = 'localRecordingDialog.dialogTitle'
                width = 'small'>
                <div className = 'local-recording-dialog'>
                    <div className = 'local-recording-dialog-description'>
                        {t('localRecordingDialog.dialogDescription')}
                    </div>
                    <div className = 'local-recording-switch-container'>
                        <label
                            className = 'local-recording-switch-label'
                            htmlFor = 'local-recording-switch'>
                            {t('localRecordingDialog.onlySelf')}
                        </label>
                        <Switch
                            id = 'local-recording-switch'
                            onChange = { this._onSwitchChange }
                            value = { !onlySelf } />
                    </div>
                    {onlySelf ? (
                        <div className = 'local-recording-info'>
                            {t(noSelfMedia ? 'localRecordingDialog.onlySelfNoMedia' : 'localRecordingDialog.onlySelfInfo')}
                        </div>
                    ) : (
                        <div className = 'local-recording-info'>
                            {t('localRecordingDialog.fullMeetingInfo')}
                        </div>
                    )}
                    {audioOnly && (
                        <div className = 'local-recording-info'>
                            {t('localRecordingDialog.onlySelfCameraOff')}
                        </div>
                    )}
                </div>
            </Dialog>
        );
    }

    _onSubmit: () => boolean;
    _onSwitchChange: () => void;
}

export default translate(connect(mapStateToProps)(StartLocalRecordingDialog));
